/**
 * @file paddle Wave Summit 2021 页的请求方法
 * @author FengGuang(fengguang01@baidu.com)
 */

import request from 'superagent';
import baseRequest from '../baseApi';
import baseRequest2 from '../baseApi2';

// 获取落地页数据数据
export const fetchGetWS2021Data = (): Promise<request.Response> =>
    baseRequest(
        request.get('/platform/page/data')
            .query({requestUrl: '/wavesummitplus2021'})
            .query(window.location.search.slice(1))
    );
        
export const fetchGetProjectSInfo = (owner: string, name: string): Promise<request.Response> =>
    baseRequest2(
        request.get(`https://api.github.com/repos/${owner}/${name}`)
    );
